export const authorizedPartyConstants = {
    SUBMIT_AUTHORIZED_PARTY_FORM_REQUEST: "SUBMIT_AUTHORIZED_PARTY_FORM_REQUEST",
    SUBMIT_AUTHORIZED_PARTY_FORM_SUCCESS: "SUBMIT_AUTHORIZED_PARTY_FORM_SUCCESS",
    SUBMIT_AUTHORIZED_PARTY_FORM_FAILURE: "SUBMIT_AUTHORIZED_PARTY_FORM_FAILURE",

    RESET_AUTHORIZED_PARTY_FORM: "RESET_AUTHORIZED_PARTY_FORM"
}